import { ChainBadgeFragment, CollectionLockupFragment } from "@opensea/app-kit"
import { graphql } from "@opensea/graphql"
import { CollectionPreviewTooltipFragment } from "../collection/CollectionPreviewTooltip/CollectionPreviewTooltip.fragment"
import { collectionUrlFragment } from "../collection/utils"
import { ItemAvatarFragment } from "../items/avatar/ItemAvatar"
import { ItemLinkFragment } from "../items/ItemLink"
import { ItemPreviewTooltipFragment } from "../items/ItemPreviewTooltip/ItemPreviewTooltip.fragment"
import { ActivityEventFragment } from "./ActivityEvent.fragment"
import { ActivityFeedLiveTimestampFragment } from "./ActivityFeedLiveTimestamp.fragment"
import { ActivityFeedMarketplaceIconFragment } from "./ActivityFeedMarketplaceIcon.fragment"
import { ActivityFeedTypeIconFragment } from "./ActivityFeedTypeIcon.fragment"
import { ActivityFromFragment } from "./ActivityFrom.fragment"
import { ActivityPriceFragment } from "./ActivityPrice.fragment"
import { ActivityQuantityFragment } from "./ActivityQuantity.fragment"
import { ActivityRarityFragment } from "./ActivityRarity.fragment"
import { ActivityToFragment } from "./ActivityTo.fragment"

export const ActivityFeedTableRowFragment = graphql(
  `
    fragment ActivityFeedTableRow on Activity {
      __typename
      id
      transactionHash
      item {
        id
        tokenId
        name
        ...ItemAvatar
        ...ItemLink
        ...ItemPreviewTooltip
        ...ActivityRarity
        chain {
          ...ChainBadge
        }
      }
      collection {
        id
        slug
        ...CollectionLockup
        ...collectionUrl
        ...CollectionPreviewTooltip
      }
      ...ActivityEvent
      ...ActivityFeedTypeIcon
      ...ActivityPrice
      ...ActivityFrom
      ...ActivityTo
      ...ActivityFeedLiveTimestamp
      ...ActivityQuantity
      ...ActivityFeedMarketplaceIcon
    }
  `,
  [
    ItemLinkFragment,
    CollectionLockupFragment,
    collectionUrlFragment,
    ActivityEventFragment,
    ActivityFeedTypeIconFragment,
    ActivityPriceFragment,
    ActivityFromFragment,
    ActivityToFragment,
    ActivityFeedLiveTimestampFragment,
    ActivityQuantityFragment,
    ItemAvatarFragment,
    ItemPreviewTooltipFragment,
    CollectionPreviewTooltipFragment,
    ActivityRarityFragment,
    ChainBadgeFragment,
    ActivityFeedMarketplaceIconFragment,
  ],
)
